import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Pașii',
        items: [
            'Scrieți la gdpr@evoomedical.ro sau depuneți la recepție o cerere scrisă. Formularul este disponibil la recepție și aici, pentru descărcare.',
            'Spuneți ce cereți: acces, copie, corectare, ștergere, restricționare, portabilitate, opoziție sau retragerea unui acord.',
            'Ca să nu dăm datele altcuiva, vă putem cere să vă confirmați identitatea.',
            'Răspundem în cel mult o lună. Când cererea e complexă, termenul se poate prelungi cu încă două luni; vă anunțăm în prima lună.',
            'Răspunsul este gratuit. Numai pentru cereri vădit nefondate sau repetate putem percepe o taxă rezonabilă ori putem refuza, cu motivare.'
        ]
    },
    {
        title: 'Dacă nu sunteți mulțumit',
        text: 'Vă puteți plânge la ANSPDCP, www.dataprotection.ro, sau vă puteți adresa instanței.'
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Regulamentul (UE) 2016/679, art. 12–22 și 77; Legea nr. 190/2018.'
    }
];

function GDPR() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Cum vă exercitați drepturile privind datele personale"
            intro="Pagina scurtă, practică: ce cereți, cui și în cât timp primiți răspunsul."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default GDPR;
